import { createSlice, PayloadAction, } from "@reduxjs/toolkit";


export interface loadingContext {
  loading: boolean;
  loadingText: string;
}


const initialValue:loadingContext={
    loading: false,
    loadingText: '',
}
 const loadingSlice = createSlice({
  name: "loadingObject",
  initialState: initialValue,
  reducers: {
    updateLoadingState: (
      _,
      action: PayloadAction<loadingContext>
    ) => {
      return action.payload;
    },


  },
});


export default loadingSlice.reducer;
export const { updateLoadingState} = loadingSlice.actions;